import { ReactComponent as UsersIcon } from 'assets/sidebar/user-icon.svg';
import { ReactComponent as VehicleIcon } from 'assets/sidebar/vehicle-icon.svg';
import { ReactComponent as WorkshopAppointmentIcon } from 'assets/sidebar/workshop-app-icon.svg';
import { ReactComponent as AlertIcon } from 'assets/sidebar/alert-icon.svg';
import { ReactComponent as OrgIcon } from 'assets/sidebar/org-icon.svg';
import { ReactComponent as AdministratorRoleIcon } from 'assets/sidebar/admin-role-icon.svg';
import { ReactComponent as MapIcon } from 'assets/sidebar/map-icon.svg';
import { ReactComponent as SatisfactionSurveyIcon } from 'assets/sidebar/satisfaction-survey-icon.svg';
import { ReactComponent as BillingIcon } from 'assets/sidebar/billing-icon.svg';
import { ReactComponent as CompanyIcon } from 'assets/sidebar/companies-icon.svg';
import { ReactComponent as OfferIcon } from 'assets/sidebar/offers.svg';

const pathname = window.location.pathname;

export interface IMenuItem {
  id: string;
  name: string;
  path: string;
  icon?: React.SVGProps<SVGSVGElement>;
  activeIcon?: React.SVGProps<SVGSVGElement>;
  selected: boolean;
  rootPath?: string;
  permissionKey?: string[];
}
export const permissionTabEnum = {
  ORGANIZATIONS: 'organization',
  USERS: 'client_user',
  VEHICLES: 'vehicles',
  COMPANIES: 'companies',
  WORKSHOP_APPOINTMENT: 'workshop_appointment',
  ADMINISTRATOR_ROLEs: 'administrator_user',
  NOTIFICATIONS: 'notifications',
  SURVEY_TEMPLATES: 'survey_templates',
  SURVEY_FEEDBACKS: 'survey_feedback',
  VEHICLE_CONFIGURATION: 'configuration',
  PROGRAMMED_ALERTS: 'programmed_alerts',
  CAMPAIGNS: 'campaigns',
  PAYMENTS: 'billing',
  ADMIN_DASHBOARD: 'admin-dashorad',
  GENERIC_ALERT: 'generic_alert',
  OFFER: 'offer',
};
export const permissionEnum = {
  ADD: 'create',
  LIST: 'list',
  DETAILS: 'details',
  EDIT: 'update',
  REMOVE: 'delete',
};

export const NotificationType = {
  COMPLETED: 'completed',
  WARNING: 'warning',
  SLEEPING: 'sleeping',
  ALERT: 'alert',
};

export const sidebarList: IMenuItem[] = [
  {
    id: 'VEHICLES',
    name: 'Vehicles',
    icon: <VehicleIcon color="#92B0BF" />,
    activeIcon: <VehicleIcon color="#ffff" />,
    path: '/vehicles',
    selected: pathname.startsWith('/vehicles') ? true : false,
    permissionKey: ['vehicles'],
  },
  {
    id: 'USERS',
    name: 'Users',
    icon: <UsersIcon color="#92B0BF" />,
    activeIcon: <UsersIcon color="#ffff" />,
    path: '/users',
    selected: pathname.startsWith('/users') ? true : false,
    permissionKey: ['client_user'],
  },
  {
    id: 'ORGANIZATIONS',
    name: 'Organizations',
    icon: <OrgIcon color="#92B0BF" />,
    activeIcon: <OrgIcon color="#ffff" />,
    path: '/organizations',
    selected: pathname.startsWith('/organizations') ? true : false,
    permissionKey: ['organization'],
  },
  {
    id: 'COMPANIES',
    name: 'Companies',
    icon: <CompanyIcon color="#92B0BF" />,
    activeIcon: <CompanyIcon color="#ffff" />,
    path: '/companies',
    selected: pathname.startsWith('/companies') ? true : false,
    permissionKey: ['companies'],
  },
  {
    id: 'WORKSHOP_APPOINTMENTS',
    name: 'Workshop appointments',
    icon: <WorkshopAppointmentIcon color="#92B0BF" />,
    activeIcon: <WorkshopAppointmentIcon color="#ffff" />,
    path: '/workshop-appointments',
    selected: pathname.startsWith('/workshop-appointments') ? true : false,
    permissionKey: ['workshop_appointment'],
  },
  {
    id: 'ALERTS_CAMPAIGN',
    name: 'Alerts & Campaigns',
    icon: <AlertIcon color="#92B0BF" />,
    activeIcon: <AlertIcon color="#ffff" />,
    path: '/alerts/generated-alerts',
    selected: pathname.startsWith('/alerts/generated-alerts') ? true : false,
    rootPath: '/alerts',
    permissionKey: ['campaigns', 'programmed_alerts', 'generic_alert'],
  },
  {
    id: 'ADMINISTRATOR_ROLES',
    name: 'Administrator roles',
    icon: <AdministratorRoleIcon color="#92B0BF" />,
    activeIcon: <AdministratorRoleIcon color="#ffff" />,
    path: '/admin-roles',
    selected: pathname.startsWith('/admin-roles') ? true : false,
    permissionKey: ['administrator_user'],
  },
  {
    id: 'MAP',
    name: 'Map',
    icon: <MapIcon color="#92B0BF" />,
    activeIcon: <MapIcon color="#ffff" />,
    path: '/map',
    selected: pathname.startsWith('/map') ? true : false,
    permissionKey: ['map'],
  },
  {
    id: 'SATISFACTION_SURVEYS',
    name: 'Satisfaction surveys',
    icon: <SatisfactionSurveyIcon color="#92B0BF" />,
    activeIcon: <SatisfactionSurveyIcon color="#ffff" />,
    rootPath: '/satisfaction-surveys',
    path: '/satisfaction-surveys/survey-templates',
    selected: pathname.startsWith('/satisfaction-surveys') ? true : false,
    permissionKey: ['survey_templates', 'survey_feedback'],
  },
  {
    id: 'BILLING',
    name: 'Payments',
    icon: <BillingIcon color="#92B0BF" />,
    activeIcon: <BillingIcon color="#ffff" />,
    path: '/payments',
    selected: pathname.startsWith('/billing') ? true : false,
    permissionKey: ['billing'],
  },
  {
    id: 'VEHICLE_CONFIG',
    name: 'Vehicle configurations',
    icon: <VehicleIcon color="#92B0BF" />,
    activeIcon: <VehicleIcon color="#ffff" />,
    path: '/vehicle-config/brands',
    rootPath: '/vehicle-config',
    selected: pathname.startsWith('/vehicle-config') ? true : false,
    permissionKey: ['configuration'],
  },
  {
    id: 'Offer_AND_TIPS',
    name: 'Offers & Tips',
    icon: <OfferIcon color="#92B0BF" height={18} width={18} />,
    activeIcon: <OfferIcon color="#ffff" height={18} width={18} />,
    path: '/offers-tips',
    selected: pathname.startsWith('/offers-tips') ? true : false,
    permissionKey: ['offer'],
  },
];
export const detailsPages = [
  'vehicle-info',
  'appointments',
  'vehicle-alerts',
  'slot-appointment',
  'survey-details',
  // 'dtc-alerts',
];
export const programmedAlertConditions = [
  { id: '=', name: '=', value: '=' },
  { id: '>', name: '>', value: '>' },
  { id: '<', name: '<', value: '<' },
  { id: '>=', name: '>=', value: '>=' },
  { id: '<=', name: '<=', value: '<=' },
  { id: 'NOT', name: 'NOT', value: 'NOT' },
];
export const programmedAlertConditionsForTime = [{ id: 'AFTER', name: 'After', value: 'AFTER' }];
export const programmedAlertFields = [
  { id: 'KM', name: 'Mileage', value: 'KM' },
  { id: 'TIME', name: 'Time', value: 'TIME' },
];
